export default __webpack_public_path__ + "static/bg-educacao-infantil-m-187015bf77982d46f40539b24b120cf4.svg";